import React from 'react';
import { Text } from '@chakra-ui/react';
var ErrorMessage = function (_a) {
    var errorMessage = _a.errorMessage;
    return (React.createElement(React.Fragment, null, errorMessage && (React.createElement(Text, { color: 'tomato', mt: 4, fontSize: 'sm' }, errorMessage))));
};
export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map